// src/js/store/index.js
import { createStore, applyMiddleware, compose } from "redux";
import { rootReducer } from "../reducers";
import { createBrowserHistory } from 'history'

//import { routerMiddleware } from 'connected-react-router';
import {thunk} from 'redux-thunk';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'



const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enhancer = composeEnhancers(
    applyMiddleware(thunk, reduxImmutableStateInvariant())
    // other store enhancers if any
    );
    
export const history = createBrowserHistory()

export default function configureStore() {
    return createStore(
        rootReducer(history),
        enhancer
    );
}